export const TEST_NAMES = {
  ADDITIONAL_SERVICES_TEST: 'additional-services-test',
  NEW_FORM_QUESTIONS: 'new-form-questions',
  SUPPLIER_SIGNUP_CTA: 'supplier-sign-up-cta',
  CATERING_ABOUT_EVENT_TEST: 'catering-about-event',
  BARS_BLOB_HERO_TEST: 'bars-blob-hero',
  ABANDON_ENQUIRY: 'enquiry-leaving-reason',
  ENQUIRY_FEASTIT_BENEFITS: 'enquiry-form-festit-benefits',
  WEDDING_CALCULATOR_TEST: 'wedding-calculator-test',
  REMOVE_ENQUIRY_WELCOME_PAGE: 'enquiry-show-welcome-page',
  MULTI_VERTICAL_PAGE_TEST: 'show-multi-vertical-pages',
  LOGGED_OUT_FAVOURITING: 'logged-out-user-favouriting',
};
